module.exports = __webpack_public_path__ + "img/estrella_completa.8c90c4fb.svg";